/** Placeholder for any billing value that is unset or could not be loaded, on screen and in exports. */
export const EMPTY_VALUE = "--";
